"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Sensor = require("@meepshop/context/lib/Sensor");

var _dropdownMenu = _interopRequireDefault(require("./dropdownMenu"));

var _largeMenu = _interopRequireDefault(require("./largeMenu"));

var _largeMenuWithImage = _interopRequireDefault(require("./largeMenuWithImage"));

var _largeMenuWithProducts = _interopRequireDefault(require("./largeMenuWithProducts"));

var _menu = require("../constants/menu");

// renderChildren 取代 children，是為了確保 className 可以被正確傳遞
var Submenu = function Submenu(_ref) {
  var renderChildren = _ref.renderChildren,
      page = _ref.page,
      style = _ref.style,
      menuSettings = _ref.menuSettings,
      onVisibleChange = _ref.onVisibleChange,
      submenuTypeProps = _ref.submenuType,
      submenuSettings = _ref.submenuSettings;
  var isPage = [_menu.MENU_ACTION_TYPES.NONE, _menu.MENU_ACTION_TYPES.PAGE, _menu.MENU_ACTION_TYPES.LINK, _menu.MENU_ACTION_TYPES.SEARCH].includes(page.action);

  var _useSensorContext = (0, _Sensor.useSensorContext)(),
      isMobile = _useSensorContext.isMobile; // 手機版固定為下拉選單


  var submenuType = isPage && !isMobile ? submenuTypeProps : _menu.SUBMENU_TYPES.DROP_DOWN;
  var submenuProps = {
    style: style,
    pages: page.pages,
    submenuSettings: submenuSettings,
    menuSettings: menuSettings,
    onVisibleChange: onVisibleChange,
    renderChildren: renderChildren
  };

  if (submenuType === _menu.SUBMENU_TYPES.LARGE_MENU) {
    return /*#__PURE__*/_react["default"].createElement(_largeMenu["default"], submenuProps);
  }

  if (submenuType === _menu.SUBMENU_TYPES.LARGE_MENU_WITH_IMAGE) {
    return /*#__PURE__*/_react["default"].createElement(_largeMenuWithImage["default"], submenuProps);
  }

  if (submenuType === _menu.SUBMENU_TYPES.LARGE_MENU_WITH_PRODUCTS) {
    return /*#__PURE__*/_react["default"].createElement(_largeMenuWithProducts["default"], submenuProps);
  }

  return /*#__PURE__*/_react["default"].createElement(_dropdownMenu["default"], submenuProps);
};

var _default = Submenu;
exports["default"] = _default;